import home1 from "../../assets/img/IMG-20251108-WA0051.jpg";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
const ourService = [
  { id: 1, name: "Landscape Design", url: "landscape-design" },
  { id: 2, name: "Hardscape", url: "hardscape" },
  { id: 3, name: "Landscape Lighting", url: "landscape-lighting" },
  { id: 4, name: "Softscape", url: "softscape" },
  { id: 5, name: "Plantation", url: "plantation" },
  { id: 6, name: "Replanting", url: "replanting" },
  {
    id: 7,
    name: "Lawn Development and Maintenance",
    url: "lawn-development-and-maintenance",
  },
  {
    id: 8,
    name: "Horticultural Maintenance",
    url: "horticultural-maintenance",
  },
  {
    id: 9,
    name: "Vertical & Terrace Garden",
    url: "vertical-and-terrace-garden",
  },
  { id: 10, name: "Irrigation System", url: "irrigation-system" },
];
function LawnDevelopment() {
  return (
    <>
      <section className="serviceList sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-12">
              <div className="aboutImg">
                <img src={home1} alt="About" className="img-fluid" />
              </div>
              <div className="blogCategory mt-4">
                <ul>
                  {ourService.map((item) => {
                    return (
                      <li key={item.id}>
                        <Link to={`${item.url}`}>
                          <FiChevronRight />
                          {item.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-lg-8 col-md-12">
              <div className="aboutWooden">
                <div className="fisherman-content">
                  <h3>🌿 Lawn Development & Maintenance</h3>
                  <p>
                    A lawn is often the first thing people notice about a garden
                    or outdoor space. It’s not just grass; it’s the foundation
                    of a landscape, a soft green carpet that sets the tone for
                    everything around it. Developing and maintaining a healthy
                    lawn requires patience, knowledge, and consistent care.
                  </p>
                  <p>
                    Lawn development begins with the right preparation —
                    selecting suitable grass types for the climate, preparing
                    soil, and ensuring proper drainage. A well-planned lawn
                    provides a resilient base that can handle daily use,
                    seasonal changes, and natural growth.
                  </p>
                  <p>
                    Maintenance is just as important as development. Regular
                    mowing, watering, fertilizing, and aerating keep the lawn
                    healthy and vibrant. Proper maintenance prevents weeds,
                    encourages thick growth, and ensures the lawn stays soft,
                    lush, and inviting year-round.
                  </p>
                  <p>
                    Authentic lawn care is about understanding nature, not
                    fighting it. Every lawn has its rhythm — the way it responds
                    to sunlight, rainfall, and seasonal variations. Paying
                    attention to these details makes a real difference, creating
                    a green space that feels alive, welcoming, and sustainable.
                  </p>
                  <p>
                    A well-developed and well-maintained lawn doesn’t just
                    beautify a space; it becomes a place to gather, relax, and
                    enjoy nature. It’s the heart of an outdoor area, bringing
                    harmony, comfort, and life to the surroundings.
                  </p>
                </div>
                <div className="fisherman-content">
                  <h5>🌿 Ready to Grow a Greener Lawn?</h5>
                  <p>
                    Whether you're starting from scratch or improving your
                    existing yard, our expert lawn care and landscaping services
                    ensure healthy, lush lawns that thrive in your local
                    climate.
                  </p>
                  <a
                    className="commonButton mt-3"
                    href="mailto:info@example.com"
                  >
                    📧 Contact Us Today
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mt-5">
              {/* Lawn Maintenance */}
              <div className="fisherman-content d-none">
                <h5>2️⃣ Grass Selection</h5>
                <ul>
                  <li>
                    🌞 Based on climate: warm-season vs. cool-season grasses
                  </li>
                  <li>🌤️ Consider sunlight/shade, usage, and soil condition</li>
                  <li>
                    🌾 Examples: Bermuda, Kentucky Bluegrass, Fescue, Ryegrass
                  </li>
                </ul>
                <h5>3️⃣ Seeding / Sodding / Sprigging</h5>
                <ul>
                  <li>🌱 Seeding – Best for budget-friendly coverage</li>
                  <li>🌿 Sodding – Instant lawn with established grass</li>
                  <li>
                    🌿 Sprigging – Root or stem planting for certain grass types
                  </li>
                </ul>
                <h5>4️⃣ Initial Care</h5>
                <ul>
                  <li>💧 Frequent light watering until roots establish</li>
                  <li>🚫 Avoid foot traffic on new lawn areas</li>
                </ul>
              </div>
              <div className="fisherman-content d-none">
                <h4>🛠️ Lawn Maintenance (Ongoing Care)</h4>
                <h5>1️⃣ Mowing</h5>
                <ul>
                  <li>✂️ Maintain proper height based on grass species</li>
                  <li>🌀 Don’t remove more than 1/3 of grass height at once</li>
                  <li>⚙️ Keep blades sharp for a clean cut</li>
                </ul>
                <h5>2️⃣ Watering</h5>
                <ul>
                  <li>💧 Deep watering, 1–1.5 inches per week</li>
                  <li>🌅 Water early in the morning to reduce evaporation</li>
                </ul>
                <h5>3️⃣ Fertilizing</h5>
                <ul>
                  <li>🧪 Use nitrogen-rich fertilizers based on season</li>
                  <li>📆 Apply 2–4 times per year</li>
                </ul>
                <h5>4️⃣ Weed Control</h5>
                <ul>
                  <li>🧹 Pre-emergent herbicides to prevent weed growth</li>
                  <li>🌿 Post-emergent to target visible weeds</li>
                  <li>🤲 Manual removal for small or sensitive areas</li>
                </ul>
                <h5>5️⃣ Aeration &amp; Dethatching</h5>
                <ul>
                  <li>🕳️ Aerate compacted soil annually (spring or fall)</li>
                  <li>
                    🧹 Remove thick thatch to allow nutrients and moisture to
                    penetrate
                  </li>
                </ul>
                <h5>6️⃣ Pest &amp; Disease Control</h5>
                <ul>
                  <li>🦗 Watch for grubs, chinch bugs, and fungus</li>
                  <li>🧴 Treat using safe, targeted pesticides or organics</li>
                </ul>
              </div>
              {/* Tips */}
              <div className="fisherman-content d-none">
                <h4>🌼 Lawn Care Tips</h4>
                <ul>
                  <li>🌱 Mow high to encourage deeper root growth</li>
                  <li>♻️ Leave grass clippings to return nutrients</li>
                  <li>🔁 Vary mowing patterns to avoid soil compaction</li>
                  <li>🚿 Don’t overwater; adjust based on rainfall</li>
                  <li>🚫 Avoid fertilizing during grass dormancy</li>
                </ul>
              </div>
              {/* Call to Action */}
            </div>
          </div>
          {/* About Lawn */}
        </div>
      </section>
    </>
  );
}

export default LawnDevelopment;
